import React from "react";
import {CalendarIcon, VaultIcon, VideoCompleteIcon} from "../../../../../assets/icons/defaultIcons";
import "./vault-card.scss";
import {useNavigate} from "react-router-dom";
import DemoImage from "../../../../../assets/images/d-image.png";
import {Progress} from "antd";

const twoColors = {
    "0%": "#40C9A2",
    "100%": "#47f3c2",
};

// Function to convert "HH:MM" or "MM:SS" format to seconds
const timeToSeconds = (timeString) => {
    if (!timeString) return 0;
    const timeParts = timeString.split(":").map(Number);
    return timeParts.length === 2
        ? timeParts[0] * 60 + timeParts[1] // MM:SS format
        : timeParts[0] * 3600 + timeParts[1] * 60 + timeParts[2]; // HH:MM:SS format (if applicable)
};

export default function VaultCard({ img, title, date, videotime, id, videoProgress }) {
    const navigate = useNavigate();

    // Convert watched time and total video time to seconds
    const watchedSeconds = timeToSeconds(videoProgress?.watchedAt);
    const totalSeconds = timeToSeconds(videotime);


    // Calculate progress percentage
    const progressPercent = totalSeconds ? Math.min((watchedSeconds / totalSeconds) * 100, 100) : 0;

    return (
        <div className={"vault-card"} onClick={() => navigate(`/vault/details/${id}`)}>
            <div className={`card-img ${!img && "demo"}`}>
                {img ? <img src={img} alt="Vault" /> : <img className={"demo-image"} src={DemoImage} alt="Demo" />}
            </div>
            <div className={"card-content"}>
                <div>
                    <h4>{title}</h4>
                    <h5>
                        <span>
                            <CalendarIcon /> {date}
                        </span>{" "}
                        <span className={"video-icon"}>
                            <VaultIcon />
                        </span>
                    </h5>
                </div>
                <h6>
                    Progress{" "}
                    <span>
                        <span className={"video-watch"}>{videoProgress?.watchedAt || "00:00"}</span> |{" "}
                        <span className={"video-time"}>{videotime || "N/A"}</span>
                    </span>
                </h6>

                <div className={"video-progress"}>
                    {progressPercent === 100 ? (
                        <span className="completed-text">Completed <VideoCompleteIcon/> </span>
                    ) : (
                        <>
                            <span>0%</span>
                            <Progress percent={Math.round(progressPercent)} size={["100%", 7]} strokeColor={twoColors} />
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
